/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { PureComponent, Fragment } from 'react';
import {
  func,
  node,
  shape,
  arrayOf,
  string,
} from 'prop-types';
import { omit } from 'ramda';
import memoize from 'fast-memoize';
import {
  Card,
  Heading,
  Button,
  Icon,
} from 'components/common';
import Filter from './Filter';

import './FiltersRefinePanel.scss';

class FiltersRefinePanel extends PureComponent {
  static propTypes = {
    children: node,
    onMobileCloseButtonClick: func,
    filters: arrayOf(shape({})),
    filterValues: shape({}),
    onFiltersChange: func,
    title: string.isRequired,
    resetButtonLabel: string.isRequired,
    onResetButtonClick: func,
  };

  static defaultProps = {
    children: [],
    onMobileCloseButtonClick: undefined,
    onFiltersChange: undefined,
    filterValues: {},
    filters: [],
    onResetButtonClick: undefined,
  };

  state = {
    timestampKey: Date.now(),
  };

  memoizedHandleFiltersChange = memoize(filter => (value) => {
    const { onFiltersChange } = this.props;
    // Backward compatible with other panels
    onFiltersChange?.({ ...filter, ...(typeof value === 'object' ? value : { value }) });
  });

  memoizedOmit = memoize(omit);

  memoizedGetFitlerValue = (queryParam) => {
    const { filterValues } = this.props;
    return filterValues[queryParam];
  };

  renderFilters = filters => filters.map(filter => (
    <Filter
      // eslint-disable-next-line
      key={`${filter.queryParam}-${this.state.timestampKey}`}
      value={this.memoizedGetFitlerValue(filter.queryParam)}
      filter={this.memoizedOmit(['defaultValue', 'value'], filter)}
      onChange={this.memoizedHandleFiltersChange(filter)}
      onBlur={this.memoizedHandleFiltersChange(filter)}
    />
  ));

  resetFilters = () => {
    this.setState({ timestampKey: Date.now() });
  }

  render() {
    const {
      children,
      onResetButtonClick,
      onMobileCloseButtonClick,
      filters,
      resetButtonLabel,
      title,
    } = this.props;

    return (
      <div className="filter-refine-panel">
        <Card className="no-border-on-mobile">
          <Card.Header>
            <Heading as="h3">
              <div className="header-wrapper">
                <div
                  className="mobile-close-button"
                  onClick={onMobileCloseButtonClick}
                >
                  <Icon medium secondary name="close_large" />
                </div>
                <span>{title}</span>
              </div>
            </Heading>
          </Card.Header>
          { children }
          <Fragment>
            {
              this.renderFilters(filters)
            }
          </Fragment>
          <Card.Content>
            <Button styleName="ghost" fluid onClick={onResetButtonClick} dataSelectorId="reset_all">
              {resetButtonLabel}
            </Button>
          </Card.Content>
        </Card>
      </div>
    );
  }
}

export default FiltersRefinePanel;
